import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the Emergent OAuth redirect: exchanges session_id (URL fragment)
// for a session cookie, then navigates to the admin dashboard.
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login");
      return;
    }

    axios
      .post(
        `${API}/auth/session`,
        { session_id: sessionId },
        { withCredentials: true, headers: { "X-Session-ID": sessionId } }
      )
      .then((res) => {
        // Clean the fragment from the URL
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: res.data } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0b0a] flex items-center justify-center">
      <div className="flex items-center gap-3 text-[#9ca399]">
        <Loader2 size={20} className="animate-spin text-[#b89b72]" />
        Signing you in…
      </div>
    </div>
  );
}
